export default __webpack_public_path__ + "static/media/tree_dot_icon.9acc9720.svg";